import React from 'react'
import { IconSeekers } from 'ui-seeker/core'
import { SelectUser } from 'app/components/commonFilters/components'
import { useAppUserSelector } from './@hooks'
import AppUserRoleIcon from 'app/@components/UserRoleIcon'


export default function AppHeaderUser({ feature, type }) {

    const { isUserMaster, username, mainUser, userID, setMainUser  } = useAppUserSelector()


    return <div className="user-block" style={{ display: 'flex', cursor: 'auto' }}>
        { !isUserMaster
            ? <>
                <div className="user-content">
                    <AppUserRoleIcon />
                </div>
                <span className="user-content" style={{ margin: '0 10px', width: 'max-content' }}>{ username }</span>
            </>
            : <div className="select-user-master">
                <SelectUser
                    value={mainUser || parseInt(userID)}
                    mainSection={true}
                    onChange={setMainUser}
                    type={type}
                    feature={feature}
                />
            </div>
        }
    </div>
}